/**
 * Environment checks - safe to import anywhere including next.config.ts.
 * Contains only process.env lookups with no client-side dependencies.
 */

export const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_APP_ENV === "dev";
export const isProduction =
  process.env.NODE_ENV === "production" &&
  process.env.NEXT_PUBLIC_APP_ENV !== "dev";
export const isTest = process.env.NODE_ENV === "test";

export type PhoenixEnv = "prod" | "beta";

export const normalizePhoenixEnv = (
  value: string | null | undefined
): PhoenixEnv | undefined => {
  if (value === null || value === undefined) return undefined;
  const normalized = value.trim().toLowerCase();
  if (normalized.length === 0) return undefined;
  if (normalized === "beta") return "beta";
  if (normalized === "prod" || normalized === "production") return "prod";
  return undefined;
};

export const getPhoenixEnv = (): PhoenixEnv =>
  normalizePhoenixEnv(process.env.NEXT_PUBLIC_PHOENIX_ENV) ?? "prod";
